import React, {FC, useState, useCallback, memo, useMemo} from 'react';
import CookieConsent, {Cookies} from "react-cookie-consent";
import Checkbox from '../../components/Inputs/Checkbox/checkbox';
import * as cookies from '../../components/Cookies';
import {
  Link
} from "react-router-dom";
import routes from '../../config/routes';

import TagManager from 'react-gtm-module';
import gtm from '../../config/gtm'


const CookieConsentWrapper:FC = () => {

  const cookieNames = useMemo(() => {
    return {
      ga: 'cookieConsentGa',
      hotjar: 'cookieConsentHj',
      facebook: 'cookieConsentFb',
      googleAds: 'cookieConsentAds',
      linkedIn: 'cookieConsentLn',
      quora: 'cookieConsentQp',
      cookieContent: 'loopCookieConsent'
    }
  }, []);
  
  const aYearFromNow = useMemo(() => {
    let aYearFromNow = new Date();
    aYearFromNow.setFullYear(aYearFromNow.getFullYear() + 1);
    return aYearFromNow;
  },[])

  const [displayCookieContent, setDisplayCookieContent] = useState<boolean>(true);
  const [fbCookie, setFbCookie] = useState<boolean>(true);
  const [googleCookie, setGoogleCookie] = useState<boolean>(true);
  const [linkedInCookie, setLinkedInCookie] = useState<boolean>(true);
  const [gaCookie, setGaCookie] = useState<boolean>(true);
  const [hotjarCookie, setHotjarCookie] = useState<boolean>(true);

  const [openCookiesDetails, setCookiesDetails] = useState<boolean>(false);

  const saveCookies = useCallback(() => {

    Cookies.set(cookieNames.cookieContent, 'true');
    Cookies.set(cookieNames.facebook, fbCookie ? '1' : '0', { secure: true, expires: aYearFromNow });
    Cookies.set(cookieNames.ga, gaCookie ? '1' : '0', { secure: true, expires: aYearFromNow  });
    Cookies.set(cookieNames.hotjar, hotjarCookie ? '1' : '0', { secure: true, expires: aYearFromNow  });
    Cookies.set(cookieNames.linkedIn, linkedInCookie ? '1' : '0', { secure: true, expires: aYearFromNow  });
    Cookies.set(cookieNames.googleAds, googleCookie ? '1' : '0', { secure: true, expires: aYearFromNow  });

    const tagManagerArgs = {
      dataLayer: {
         'event': gtm.events.formSubmitted,
      },
    }
    TagManager.dataLayer(tagManagerArgs)

    setDisplayCookieContent(false);
  },[cookieNames, fbCookie, googleCookie, linkedInCookie, gaCookie, hotjarCookie, aYearFromNow, setDisplayCookieContent])


  const toggleCookiesDetails = useCallback((e) => {
    if(openCookiesDetails) {
      setCookiesDetails(false);
    } else {
      setCookiesDetails(true);
    }
  }, [openCookiesDetails]);


    return (
      displayCookieContent ?
      <CookieConsent
        location="bottom"
        buttonText="Dozvoli sve"
        cookieName={cookieNames.cookieContent}
        disableButtonStyles={true}
        expires={365}
        onAccept={()=> {
          //accept all
          Cookies.set(cookieNames.facebook, '1', { secure: true, expires: aYearFromNow });
          Cookies.set(cookieNames.ga, '1', { secure: true, expires: aYearFromNow });
          Cookies.set(cookieNames.hotjar, '1', { secure: true, expires: aYearFromNow });
          Cookies.set(cookieNames.linkedIn, '1', { secure: true, expires: aYearFromNow });
          Cookies.set(cookieNames.googleAds, '1', { secure: true, expires: aYearFromNow });
          
          setDisplayCookieContent(false);
        }}
        disableStyles={true}
        containerClasses={`cookies ${openCookiesDetails ? 'showDetails' : ''}`}
        contentClasses="cookies__content"
        buttonWrapperClasses="cookies__details"
        buttonClasses="cookies__save"
      >
        <cookies.CookiesContent className={openCookiesDetails ? 'showDetails' : ''}>
          <h3>Saglasnost o kolačićima</h3>
          <p> Naš sajt koristi kolačiće u cilju unapređenja korisničkog iskustva, analize saobraćaja i ciljanog marketinga. Za više informacija pogledaj <Link to={routes.CookiesPolicy}>Politiku Kolačića</Link> i odaberi podešavanje kolačića.</p>
          <cookies.ButtonsInline>

            {openCookiesDetails ?
              <span onClick={toggleCookiesDetails}>Manje detalja <i>{'<'}</i></span>
              :
              <span onClick={toggleCookiesDetails}>Više detalja <i>{'>'}</i></span>
            }
          </cookies.ButtonsInline>
        </cookies.CookiesContent>
        <cookies.CookiesDetails className={openCookiesDetails ? 'showDetails' : ''}>
          <Checkbox onCheckboxChange={()=> {}} isChecked={true} text={'Samo neophodni'}  />
          <cookies.CookiesDetailsRow>
            <cookies.CookiesDetailsCol>
              <h4> Marketing kolačići</h4>
              <ul>
                <li><Checkbox onCheckboxChange={(value: boolean)=> setFbCookie(value)} isChecked={fbCookie} text={'Facebook'}  /></li>
                <li><Checkbox onCheckboxChange={(value: boolean)=> setGoogleCookie(value)} isChecked={googleCookie} text={'Google Ads'}  /></li>
                <li><Checkbox onCheckboxChange={(value: boolean)=> setLinkedInCookie(value)} isChecked={linkedInCookie} text={'LinkedIn Insights'} /></li>
              </ul>
            </cookies.CookiesDetailsCol>
            <cookies.CookiesDetailsCol>
              <h4>Funkcionalni kolačići</h4>
              <ul>
                <li><Checkbox onCheckboxChange={(value: boolean)=> setGaCookie(value)} isChecked={gaCookie} text={'Google Analytics'} /></li>
                <li><Checkbox onCheckboxChange={(value: boolean)=> setHotjarCookie(value)} isChecked={hotjarCookie} text={'Hotjar'} /></li>
              </ul>
            </cookies.CookiesDetailsCol>
          </cookies.CookiesDetailsRow>
          <button onClick={saveCookies} >Sačuvaj i zatvori</button>
        </cookies.CookiesDetails>
      </CookieConsent> : <></>
    )
  }

export default memo(CookieConsentWrapper);
